import { datadogRum } from '@datadog/browser-rum';
import h, { getReduxGlobal } from '../helpers/common';
import { appConfig } from '../config/app.config';
import user from '../helpers/user';
import { showGuestRedirectModal } from '../store/reducers/generalConfigurationSlice';
import { markDataDogSessionForRenew } from '@intigral/utils/lib/datadog';
import { isGuestUser } from './guards';
import { clearWcpClientAuthState } from './session';
import type { GuestAwareUser } from './types';

export function getGuestRedirectionUrl(logoutUrl: string): string {
    if (!logoutUrl) {
        return '';
    }
    try {
        const parsed = new URL(logoutUrl);
        parsed.searchParams.delete('action');
        return parsed.toString();
    } catch {
        return logoutUrl;
    }
}

export function getFreeTrailCtaUrl(): string {
    const baseUrl = process.env.NX_PUBLIC_SUBSCRIPTION_BASE_URL;
    const lang = h.getLang() === appConfig.defaultLanguage ? '' : h.getLang();
    const pathname = lang ? `/${lang}/sa/tiers/paid` : 'ar/sa/tiers/paid';

    if (!baseUrl) {
        return pathname;
    }

    try {
        const parsed = new URL(baseUrl);
        parsed.pathname = pathname;
        return parsed.toString();
    } catch {
        return pathname;
    }
}

/** Navigate to sign-in without clearing auth first (avoids re-render crash on undefined userInfo). */
export function redirectGuestToSignIn(): void {
    // Guests have no logout — stop session; next page renews via consent toggle
    if (appConfig.dataDogRUM.isEnabled) {
        datadogRum.stopSession();
        markDataDogSessionForRenew();
    }

    const href = getGuestRedirectionUrl(user.getUserLogoutUrl());
    if (href) {
        window.location.assign(href);
        return;
    }
    clearWcpClientAuthState({ skipRedux: true });
}

export function handleGuestRedirection(args: {
    user: GuestAwareUser | undefined;
    logoutUrl: string;
    event?: { preventDefault?: () => void };
}): boolean {
    if (!isGuestUser(args.user)) {
        return false;
    }
    args.event?.preventDefault?.();
    getReduxGlobal().dispatch(showGuestRedirectModal(true));
    return true;
}

/** Show guest sign-in modal for gated UI actions (no redirect). */
export function showGuestPromotionPopup(event?: {
    preventDefault?: () => void;
    stopPropagation?: () => void;
}): boolean {
    return handleGuestRedirection({
        user: user.getUserInfo(),
        logoutUrl: user.getUserLogoutUrl(),
        event,
    });
}
